export const engagementAppGroupIdCanvasContentOptimizerSteps =
  "/engagement/:app_group_id/canvas/content_optimizer_steps";
